import { render, staticRenderFns } from "./payline.vue?vue&type=template&id=2bfa245f&scoped=true&"
import script from "./payline.js?vue&type=script&lang=js&"
export * from "./payline.js?vue&type=script&lang=js&"
import style0 from "./payline.vue?vue&type=style&index=0&id=2bfa245f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfa245f",
  null
  
)

export default component.exports